
import { Component, Prop, Vue } from "vue-property-decorator";
import Typewriter from "./Typewriter.vue";
import { Storylines, Inventory } from "../scenes/models";

@Component({
  components: { Typewriter },
})
export default class Hints extends Vue {
  @Prop() readonly storylines!: Storylines;
  @Prop() readonly inventory!: Inventory;

  get sound() {
    return localStorage.sound === 'true'
  }

  mounted() {
    window.addEventListener("keydown", (e: any) => {
      if (e.code === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        this.$emit('close')
      }
    })
  }

  startMessage = false;
  sonny = require("@/images/yang.png");

  get hint() {
    if (this.storylines.darethDemoted) {
      return {
        message: "Now’s my chance to take back what’s rightfully mine.",
        audio: require("@/audio/Hint 16-MP3.mp3"),
      };
    }

    if (this.storylines.goneToShibariOffice) {
      return {
        message: `"Dareth Schamren seems to be enjoying his time working from home a little too much. Perhaps he’d feel differently if he were to be forced to head into the office."`,
        audio: require("@/audio/Hint 15-MP3.mp3"),
      };
    }

    if (this.inventory.shibariKeyCard.has) {
      return {
        message: `"Where in God’s name is the Shibari International local branch office?"`,
        audio: require("@/audio/Hint 14-MP3.mp3"),
      };
    }

    if (this.storylines.eavesdropped) {
      return {
        message: `"There must be some way to get Dareth Schamren off his toilet."`,
        audio: require("@/audio/Hint 13-MP3.mp3"),
      };
    }

    if (this.storylines.bittenBySpider) {
      return {
        message: `"There must be some way to search those ceramic pots without being hassled by venomous wildlife. Perhaps the solution to this predicament lies on the CRUISE SHIP THAT’S BEEN QUARANTINED AT THE DOCKS."`,
        audio: require("@/audio/Hint 12-MP3.mp3"),
      };
    }

    if (this.storylines.dogHasBeenTamed && !this.inventory.key.has) {
      return {
        message: `"Where in God’s name is Dareth’s spare front door key?"`,
        audio: require("@/audio/Hint 11-MP3.mp3"),
      };
    }

    if (this.inventory.creditCard.has && !this.storylines.burgerPurchased) {
      return {
        message: `"With that cash deposited, I’ll now be able to make use of the contactless payment feature offered by most businesses."`,
        audio: require("@/audio/Hint 10-MP3.mp3"),
      };
    }

    if (this.storylines.findAtm) {
      return {
        message: `"Where in God’s name is the nearest ATM?"`,
        audio: require("@/audio/Hint 8-MP3.mp3"),
      };
    }

    if (this.storylines.atmFound && !this.inventory.creditCard.has) {
      return {
        message:
          "There are ten-thousand possible four-digit combinations that may comprise a bank PIN code. Interestingly, studies have shown that only nine-thousand, seven-hundred and ninety-eight of them have ever been used throughout history.",
        audio: require("@/audio/Hint 9-MP3.mp3"),
      };
    }

    if (this.storylines.fenceOpened) {
      return {
        message:
          "Perhaps I’d be able to distract Dareth Schamren’s guard dog with something else to chew on other than my delicate human flesh.”",
        audio: require("@/audio/Hint 7-MP3.mp3"),
      };
    }

    if (this.storylines.findGlenn) {
      return {
        message:
          "My friend Glenn might be able to help me get through Dareth Schamren's fence. That chump will do anything I tell him.",
        audio: require("@/audio/Hint 5-MP3.mp3"),
      };
    }

    if (this.storylines.buyDiapers) {
      return {
        message: `"There must be some way to fool that officer into thinking I'm a single parent with child."`,
        audio: require("@/audio/Hint 6-MP3.mp3"),
      };
    }

    if (this.storylines.seekRevenge) {
      return {
        message: `"Looks like I'll have to pay Dareth Schamren a little visit"`,
        audio: require("@/audio/Hint 4-MP3.mp3"),
      };
    }

    if (this.storylines.acquireSupplies) {
      return {
        message: `"I'll need to stock up on quarantine supplies."`,
        audio: require("@/audio/Hint 3-MP3.mp3"),
      };
    }

    if (this.storylines.findSupermarket) {
      return {
        message: `"Where in god's name is that supermarket?"`,
        audio: require("@/audio/Hint 2-MP3.mp3"),
      };
    }

    if (this.storylines.findBag) {
      return {
        message: `"Where in god's name did I put that re-useable grocery bag?"`,
        audio: require("@/audio/Hint 1-MP3.mp3"),
      };
    }

    return "Damn you Dareth Schamren!";
  }
}
